import React from 'react'
import { ViewLabelwithDataBg } from '../../../components/View/ViewLabelwithData';
import { CloseIcon } from '../../../assets/icons';
import { EmailNoteList } from '../../../assets/data/CountryMini';

function ViewEmailTemplate({ visible, onClose, data }) {
    if (!visible) return null;
    return (
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
    flex justify-center items-center z-10"
      >
        <div className="bg-white p-2 rounded w-6/12 max-h-[calc(100vh-80px)] overflow-hidden">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-xl capitalize font-semibold">
             {"Email Template View"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon />
            </span>
          </div>
          <div className="overflow-y-auto max-h-[calc(100vh-140px)]">
            <div>
              <ViewLabelwithDataBg title="Status" value={
                data?.status_name == "completed" ? "Completed":
                data?.status_name == "in progress" ? "In Progress":
                data?.status_name == "yet to start" ? "Yet to Start":
                data?.status_name == "review_and_approved" ? "Reviewed and Approved":
                data?.status_name == "reminder" ? "Reminder":
                data?.status_name == "one month alert" ? "Standard Expiry Alert Before One Month":
                data?.status_name == "one week alert" ? "Standard Expiry Alert Before One Week":
                data?.status_name == "one day before alert" ? "Standard Expiry Alert Before One Day":
                data?.status_name == "after one day alert" ? "Standard Expiry Alert After One Day":
                data?.status_name == "Standard Reset" ? "Standard Reset":"-"
                || "-"} />
              <ViewLabelwithDataBg title="Subject" value={data?.subject || "-"} />
              <ViewLabelwithDataBg title="Message" value={data?.message || "-"} />

            </div>
            <div className="w-full px-8 pb-6">
                  <p className=" text-[13px] font-medium mt-4 mb-1">Note : <span className=" text-xs font-normal text-gray-500 mb-2">Please use this keywords for the Email Template </span></p>
                  <table>
                    <tbody>
                      {
                        EmailNoteList.map((note, i) => (
                          <tr key={i}>
                            <td className="text-xs text-gray-500 w-[105px] py-0.5">{note.key}</td>
                            <td className="text-xs text-gray-500 w-[10px] py-0.5">:</td>
                            <td className="text-xs text-gray-500 py-0.5">{note.value}</td>
                          </tr>
                        )
                    )}
                    </tbody>
                  </table>
                </div>
          </div>
        </div>
      </div>
    );
}

export default ViewEmailTemplate